"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEditorTheme = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const mui_rte_1 = __importDefault(require("mui-rte"));
const clsx_1 = __importDefault(require("clsx"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const styles_1 = require("@material-ui/core/styles");
exports.defaultEditorTheme = styles_1.createMuiTheme();
Object.assign(exports.defaultEditorTheme, {
    overrides: {
        MUIRichTextEditor: {
            root: {
                height: '100%',
            },
            container: {
                display: 'flex',
                flexDirection: 'column-reverse',
                height: '100%',
            },
            editor: {
                overflowY: 'auto',
                height: '100%',
                '& ul': {
                    marginLeft: 5,
                },
                '& ol': {
                    marginLeft: 24,
                },
            },
        },
    },
});
const useStyles = styles_1.makeStyles((theme) => ({
    editorContainer: {
        flex: 1,
        position: 'relative',
    },
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.05)',
    },
}));
const RichTextViewer = (props) => {
    const { value, overlay, container, ...otherProps } = props;
    const classes = useStyles();
    const valueStr = typeof value === 'string' ? value : JSON.stringify(value);
    return (react_1.default.createElement(Box_1.default, Object.assign({}, otherProps, { className: clsx_1.default(classes.editorContainer, overlay && classes.overlay, container && container) }),
        react_1.default.createElement(styles_1.MuiThemeProvider, { theme: exports.defaultEditorTheme },
            react_1.default.createElement(mui_rte_1.default, { defaultValue: valueStr, controls: [], readOnly: true }))));
};
RichTextViewer.propTypes = {
    value: prop_types_1.default.string.isRequired,
    overlay: prop_types_1.default.bool,
    container: prop_types_1.default.string,
};
exports.default = RichTextViewer;
